
export default {

  data() {
    return {
      merchantPhone: null,
    }
  },

  // Check login
  mounted() {
    //Pass expected role for auth
    this.merchantPhone = this.$config.GTHPH

  },
  // All the functions for the add area form are written here
  methods: {
    removeSpace(num){
      return num.replace(/\s/g, "")
    },

  },
}
